import React, { Component } from 'react';
import PropTypes from 'prop-types';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Timeout = function (_Component) {
  inherits(Timeout, _Component);

  function Timeout() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Timeout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Timeout.__proto__ || Object.getPrototypeOf(Timeout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inSuspense: false,
      didExpire: false
    }, _this._expireTimeout = null, _this._suspender = null, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Timeout, [{
    key: 'componentDidCatch',
    value: function componentDidCatch(err, info) {
      var _this2 = this;

      if (typeof err.then === 'function') {
        var suspender = err;
        this._suspender = suspender;
        this._initTimeout();
        this.setState({ inSuspense: true });

        var update = function update() {
          if (_this2._suspender !== suspender) return;
          _this2.setState({ inSuspense: false });
          _this2._clearTimeout();

          if (_this2.state.didExpire) {
            _this2.setState({ didExpire: false });
          } else {
            _this2.forceUpdate();
          }
        };

        suspender.then(update, update);
      } else {
        // rethrow non-promise errors
        throw err;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          suspense = _props.suspense;
      var _state = this.state,
          inSuspense = _state.inSuspense,
          didExpire = _state.didExpire;


      if (inSuspense && !didExpire) {
        // optional: strictly for the purpose of demoing how suspense works
        return suspense;
      } else {
        return children(didExpire);
      }
    }
  }, {
    key: '_initTimeout',
    value: function _initTimeout() {
      var _this3 = this;

      var ms = this.props.ms;


      this._clearTimeout();

      this._expireTimeout = setTimeout(function () {
        _this3.setState({ didExpire: true });
      }, ms);
    }
  }, {
    key: '_clearTimeout',
    value: function _clearTimeout() {
      if (this._expireTimeout) {
        clearTimeout(this._expireTimeout);
        this._expireTimeout = null;
      }
    }
  }]);
  return Timeout;
}(Component);

Timeout.propTypes = {
  ms: PropTypes.number,
  suspense: PropTypes.node,
  children: PropTypes.func.isRequired
};
Timeout.defaultProps = {
  ms: 0,
  suspense: null
};

function Placeholder(props) {
  var delayMs = props.delayMs,
      fallback = props.fallback,
      suspense = props.suspense,
      children = props.children;


  return React.createElement(
    Timeout,
    { ms: delayMs, suspense: suspense },
    function (didExpire) {
      return didExpire ? fallback : children;
    }
  );
}

Placeholder.propTypes = {
  delayMs: PropTypes.number,
  fallback: PropTypes.node,
  suspense: PropTypes.node,
  children: PropTypes.node
};

Placeholder.defaultProps = {
  fallback: null,
  suspense: null,
  children: null
};

export { Placeholder, Timeout };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 27
// module chunks = 0